import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import type { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { focusElementWithFallback, getFocusReturnTarget } from '@go-modules/utilities';

export interface ConfirmDialogData {
	title: string;
	message: string;
	note?: string;
	cancelText?: string;
	confirmText?: string;
	confirmStyle?: string;
	warningNote?: boolean;
}
export interface ConfirmDialogConfig {
	disableClose?: boolean;
}

@Component({
	selector: 'app-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss'],
	standalone: false
})
export class ConfirmDialogComponent {
	public constructor (
		public dialogRef: MatDialogRef<ConfirmDialogComponent, boolean>,
		@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
	) {}

	// A small helper to open the dialog with all the correct typing
	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<ConfirmDialogData>
	): MatDialogRef<ConfirmDialogComponent, boolean> {
		const focusReturnTarget = getFocusReturnTarget(document);
		const dialogRef = dialog.open<ConfirmDialogComponent, ConfirmDialogData, boolean>(ConfirmDialogComponent, {
			...(config ?? {}),
			// restoreFocus: false is intentional here because Material’s default restore target
			// is “the element focused when dialog opened.” In our flows that is often:
			// a menu item that gets removed when menu closes, or something similar
			restoreFocus: false
		});

		dialogRef.afterClosed().subscribe(() => {
			focusElementWithFallback(focusReturnTarget);
		});

		return dialogRef;
	}

	public close () {
		this.dialogRef.close(null);
	}

	public cancel () {
		this.dialogRef.close(false);
	}

	public confirm () {
		this.dialogRef.close(true);
	}
}
